import {
    Grid,
    TextField,
    Typography,
    Button,
    CircularProgress,
    Snackbar,
    Alert,
    Box,
    IconButton
} from "@mui/material";
import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { db } from "../../../firebase/firebase";
import { doc, getDoc, updateDoc } from "firebase/firestore";
import { getStorage, ref, uploadBytes, getDownloadURL } from "firebase/storage";
import DeleteIcon from '@mui/icons-material/Delete';

const storage = getStorage();
const Editar_Proyecto_Dashboard = () => {

    const { id } = useParams();
    const [title, setTitle] = useState("");
    const [sitio, setSitio] = useState("");
    const [anio, setAnio] = useState("");
    const [cliente, setCliente] = useState("");
    const [descripcion, setDescripcion] = useState("");
    const [images, setImages] = useState([]);
    const [existingImageUrls, setExistingImageUrls] = useState([]);
    const [loading, setLoading] = useState(false);
    const [snackbarOpen, setSnackbarOpen] = useState(false);

    useEffect(() => {
        const fetchProyecto = async () => {
            try {
                const docRef = doc(db, "proyectos", id);
                const docSnap = await getDoc(docRef);
                if (docSnap.exists()) {
                    const data = docSnap.data();
                    setTitle(data.title || "");
                    setSitio(data.sitio || "");
                    setAnio(data.anio || "");
                    setCliente(data.cliente || "");
                    setDescripcion(data.descripcion || "");
                    setExistingImageUrls(data.imageUrls || []);
                }
            } catch (error) {
                console.error("Error al cargar el proyecto:", error);
            }
        };

        fetchProyecto();
    }, [id]);

    const handleImageChange = (e) => {
        setImages([...e.target.files]);
    };

    const uploadImages = async () => {
        const uploadedUrls = [];

        for (const image of images) {
            const storageRef = ref(storage, `proyectos/${id}/${image.name}`);
            const snapshot = await uploadBytes(storageRef, image);
            const url = await getDownloadURL(snapshot.ref);
            uploadedUrls.push(url);
        }

        return uploadedUrls;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (isNaN(anio)) {
            alert("El año debe ser un número.");
            return;
        }

        setLoading(true);
        try {
            const nuevasUrls = await uploadImages();
            const todasLasImagenes = [...existingImageUrls, ...nuevasUrls];

            await updateDoc(doc(db, "proyectos", id), {
                title,
                sitio,
                anio,
                cliente,
                descripcion,
                imageUrls: todasLasImagenes,
            });

            setSnackbarOpen(true);
            setImages([]);
        } catch (error) {
            console.error("Error al actualizar el proyecto:", error);
        } finally {
            setLoading(false);
        }
    };

    const handleDeleteImage = async (url) => {
        const confirm = window.confirm("¿Eliminar esta imagen del proyecto?");
        if (!confirm) return;

        const nuevaLista = existingImageUrls.filter((imgUrl) => imgUrl !== url);
        setExistingImageUrls(nuevaLista);

        await updateDoc(doc(db, "proyectos", id), {
            imageUrls: nuevaLista,
        });
    };
    return (
        <>
            <Grid container justifyContent={"center"} alignItems={"flex-start"} size={{ xs: 12, sm: 12, md: 11 }}>
                <Grid
                    component="form"
                    onSubmit={handleSubmit}
                    container
                    size={{ xs: 12, sm: 12, md: 11 }}
                    sx={{ maxWidth: 500, px: 3, pt: 10 }}
                >
                    <TextField
                        label="Nombre del proyecto"
                        fullWidth
                        margin="normal"
                        value={title}
                        onChange={(e) => setTitle(e.target.value)}
                    />
                    <TextField
                        label="Sitio"
                        fullWidth
                        margin="normal"
                        value={sitio}
                        onChange={(e) => setSitio(e.target.value)}
                    />
                    <TextField
                        label="Año"
                        fullWidth
                        margin="normal"
                        value={anio}
                        onChange={(e) => setAnio(e.target.value)}
                        type="number"
                    />
                    <TextField
                        label="Cliente"
                        fullWidth
                        margin="normal"
                        value={cliente}
                        onChange={(e) => setCliente(e.target.value)}
                    />
                    <TextField
                        label="Descripción"
                        fullWidth
                        multiline
                        rows={5}
                        margin="normal"
                        value={descripcion}
                        onChange={(e) => setDescripcion(e.target.value)}
                    />

                    <Button component="label" variant="outlined" fullWidth sx={{ my: 2 }}>
                        Seleccionar imágenes
                        <input
                            type="file"
                            hidden
                            accept="image/*"
                            multiple
                            onChange={handleImageChange}
                        />
                    </Button>

                    {images.length > 0 && (
                        <Typography variant="body2">{images.length} imagen(es) seleccionadas para subir</Typography>
                    )}

                    {/* Imágenes actuales */}
                    {existingImageUrls.length > 0 && (
                        <Box sx={{ mt: 2 }}>
                            <Typography variant="subtitle1">Imágenes actuales:</Typography>
                            <Grid container spacing={2}>
                                {existingImageUrls.map((url, index) => (
                                    <Grid item xs={6} key={index}>
                                        <Box sx={{ position: "relative" }}>
                                            <img src={url} alt={`img-${index}`} style={{ width: "100%", borderRadius: 8 }} />
                                            <IconButton
                                                size="small"
                                                onClick={() => handleDeleteImage(url)}
                                                sx={{ position: "absolute", top: 5, right: 5, bgcolor: "white" }}
                                            >
                                                <DeleteIcon fontSize="small" />
                                            </IconButton>
                                        </Box>
                                    </Grid>
                                ))}
                            </Grid>
                        </Box>
                    )}

                    <Button type="submit" variant="contained" disabled={loading} sx={{ mt: 3 }}>
                        {loading ? <CircularProgress size={24} /> : "Guardar Cambios"}
                    </Button>
                </Grid>
            </Grid>

            <Snackbar
                open={snackbarOpen}
                autoHideDuration={3000}
                onClose={() => setSnackbarOpen(false)}
                anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
            >
                <Alert onClose={() => setSnackbarOpen(false)} severity="success" sx={{ width: "100%" }}>
                    Proyecto actualizado correctamente
                </Alert>
            </Snackbar>
        </>
    )

}
export default Editar_Proyecto_Dashboard;
//
//
//
// import { useParams } from "react-router-dom";
// import { useEffect, useState } from "react";
// import { db } from "../../../firebase/firebase";
// import { doc, getDoc, updateDoc } from "firebase/firestore";
// import { TextField, Button, Typography, Grid} from "@mui/material";
//
//
// const Editar_Proyecto_Dashboard = () => {
//
//     const { id } = useParams();
//     const [proyecto, setProyecto] = useState({ title: "" });
//     const [cargando, setCargando] = useState(true);
//
//     useEffect(() => {
//         const fetchProyecto = async () => {
//             try {
//                 const docRef = doc(db, "proyectos", id);
//                 const docSnap = await getDoc(docRef);
//                 if (docSnap.exists()) {
//                     setProyecto(docSnap.data());
//                 }
//                 setCargando(false);
//             } catch (error) {
//                 console.error("Error al obtener proyecto:", error);
//             }
//         };
//         fetchProyecto();
//     }, [id]);
//
//     const handleChange = (e) => {
//         setProyecto({ ...proyecto, [e.target.name]: e.target.value });
//     };
//
//     const handleGuardar = async () => {
//         try {
//             await updateDoc(doc(db, "proyectos", id), proyecto);
//             alert("Proyecto actualizado correctamente");
//         } catch (error) {
//             console.error("Error al actualizar proyecto:", error);
//         }
//     };
//
//     if (cargando) return <Typography>Cargando...</Typography>;
//
//
//     return (
//         <Grid
//             container
//             justifyContent={'center'}
//             alignItems={'flex-start'}
//             size={{xs: 12, sm: 12, md: 12}}>
//             <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{maxWidth:1400, px:3}}>
//                 <Typography variant="h5">Editar Proyecto</Typography>
//                 <TextField
//                     fullWidth
//                     label="Título"
//                     name="title"
//                     value={proyecto.title}
//                     onChange={handleChange}
//                     sx={{ my: 2 }}
//                 />
//                 {/* Aquí puedes agregar más campos */}
//                 <Button variant="contained" onClick={handleGuardar}>
//                     Guardar Cambios
//                 </Button>
//             </Grid>
//
//         </Grid>
//     )
//
// }
// export default Editar_Proyecto_Dashboard;